import { useVersionInfo } from '@/hooks/useVersionInfo';
import React from 'react';

interface VersionInfoProps {
  variant?: 'header' | 'floating';
}

/**
 * Displays app and API versions in a compact, reusable badge.
 */
export const VersionInfo: React.FC<VersionInfoProps> = ({ variant = 'header' }) => {
  const { appVersion, apiVersion, isLoading } = useVersionInfo();
  const displayedApiVersion = isLoading ? '...' : apiVersion;

  return (
    <div
      className={`version-chip version-chip--${variant}`}
      title={`App ${appVersion} | API ${displayedApiVersion}`}
      aria-label={`Application version ${appVersion} and API version ${displayedApiVersion}`}
    >
      <span className="version-chip__label">App {appVersion}</span>
      <span className="version-chip__separator" aria-hidden="true">
        |
      </span>
      <span className="version-chip__label">API {displayedApiVersion}</span>
    </div>
  );
};
